import * as React from 'react';
import { ModalWindow, UIText1, UIText2, UIHeading4, Button } from '@cian/ui-kit';
import classnames from 'classnames';

import { useDeviceCondition, useIsMobileDevice } from '../../hooks';

import * as styles from './SubagentNotEnoughMoneyModal.css';

interface IProps {
  isOpen: boolean;
  title: string;
  onClose(): void;
  onSaveDraft(): void;
  onChangeMoneySource(): void;
}

export const SubagentNotEnoughMoneyModal = ({ isOpen, title, onClose, onSaveDraft, onChangeMoneySource }: IProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);
  const UIText = useDeviceCondition(UIText2, UIText1);
  const isMobile = useIsMobileDevice();

  return (
    <ModalWindow open={isOpen} title={title} width={580} onClose={onClose}>
      <div className={classnames(rootStyle, styles['wrapper'])}>
        <UIText>Переключитесь на личный счёт, чтобы опубликовать объявление</UIText>

        <div className={classnames(rootStyle, styles['btns-container'])}>
          <Button fullWidth={isMobile} theme="fill_primary" onClick={onChangeMoneySource}>
            Переключиться на личный счёт
          </Button>

          <div className={styles['save-draft-btn']} onClick={onSaveDraft}>
            <UIHeading4 color="primary_100">Сохранить черновик</UIHeading4>
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};
